<component :is="componentName" :collection="collection"></component>